module.exports = __webpack_public_path__ + "fonts/Graphik-RegularItalic.242d8fd5.woff";